<template>
  <v-overlay
    :value="getLoading"
    style="z-index: 9999999999999999999 !important"
  >
    <div class="text-center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="secondary"
        indeterminate
      />
    </div>
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VLoading',

  computed: {
    ...mapGetters('loading', ['getLoading']),
  },
};
</script>